import * as React from "react";
import { CoverageLevelDisplay } from "../../../../../../store/Policies/Displays";
import { Policy } from "../../../../../../store/Policies/Types";
import { ThemeShadowSizes, ThemePalette } from "@vwpfs/mary-air-lib/theme/_Types";
import { licensePlate } from "@vwpfs/mary-air-lib/utils/FormatHelpers";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";
import { Grid } from "@vwpfs/mary-air-lib/components/air/03-base/Grid";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { FieldSet } from "@vwpfs/mary-air-lib/components/air/06-molecules/FieldSet";
import { FormTextArea } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form/TextArea";
import { Form } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form";
import { FieldTypes, FormField } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form/Field";


interface Props {
    general: Policy;
}
/**
 *
 * @param props
 */
export const GeneralView: React.FC<Props> = (props: Props) => (
    <React.Fragment>
        <Div theme={{ shadow: ThemeShadowSizes.TINY }}>
            <Container
                theme={{
                    palette: ThemePalette.CONTRAST_PRIMARY,
                    padding: {
                        "": { y: 3 },
                        "sm": { y: 4 },
                    },
                }}
            >
                <Form>
                    <FieldSet title="Policy info">
                        <Div className="scl-b-row">
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <FormField
                                    type={FieldTypes.Text}
                                    label="Policy number"
                                    value={props.general.policyNumber}
                                    asSummary
                                />
                            </Grid>
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <FormField
                                    type={FieldTypes.Text}
                                    label="License plate"
                                    value={props.general.licensePlate ? licensePlate(props.general.licensePlate) : ""}
                                    asSummary
                                />
                            </Grid>
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <FormField
                                    type={FieldTypes.Text}
                                    label="Chassis number"
                                    value={props.general.chassisNumber}
                                    asSummary
                                />
                            </Grid>
                        </Div>
                        <Div className="scl-b-row">
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <FormField
                                    label="Start Date Factory Warranty"
                                    type={FieldTypes.Date}
                                    value={props.general.startDateFactoryWarranty}
                                    asSummary
                                />
                            </Grid>
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <FormField
                                    label="End Date Factory Warranty"
                                    type={FieldTypes.Date}
                                    value={props.general.endDateFactoryWarranty}
                                    asSummary
                                />
                            </Grid>
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <FormField
                                    label="Duration"
                                    type={FieldTypes.Number}
                                    value={props.general.duration}
                                    asSummary
                                />
                            </Grid>
                        </Div>
                        <Div className="scl-b-row">
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <FormField
                                    label="Start Date Extended Warranty"
                                    type={FieldTypes.Date}
                                    value={props.general.startDateExtendedWarranty}
                                    asSummary
                                />
                            </Grid>
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <FormField
                                    label="Receiving date"
                                    type={FieldTypes.Date}
                                    value={props.general.receivingDate
                                        ? props.general.receivingDate : "n.a."}
                                    asSummary
                                />
                            </Grid>
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <FormField
                                    label="Max kilometers"
                                    type={FieldTypes.Number}
                                    value={props.general.maxMileage}
                                    asSummary
                                />
                            </Grid>
                        </Div>
                        <Div className="scl-b-row">
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <FormField
                                    label="Proxy"
                                    type={FieldTypes.Text}
                                    value={props.general.proxy?.name ?? ""}
                                    asSummary
                                />
                            </Grid>
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <FormField
                                    label="Contract type (PAH)"
                                    type={FieldTypes.Text}
                                    value={props.general.contractTypePah}
                                    asSummary
                                />
                            </Grid>
                        </Div>
                    </FieldSet>
                    {props.general.policyHolder &&
                            <FieldSet title="Policy holder">
                                <Div className="scl-b-row">
                                    <Grid
                                        size={{ xs: 12, md: 4 }}
                                    >
                                        <FormField
                                            label="Name"
                                            type={FieldTypes.Text}
                                            value={props.general.policyHolder.name}
                                            asSummary
                                        />
                                    </Grid>
                                    <Grid
                                        size={{ xs: 12, md: 4 }}
                                    >
                                        <FormField
                                            label="Partner number"
                                            type={FieldTypes.Text}
                                            value={props.general.policyHolder.partnerNumber}
                                            asSummary
                                        />
                                    </Grid>
                                    <Grid
                                        size={{ xs: 12, md: 4 }}
                                    >
                                        <FormField
                                            label="Partner number (PAH)"
                                            type={FieldTypes.Text}
                                            value={props.general.policyHolder.partnerNumberPah}
                                            asSummary
                                        />
                                    </Grid>
                                </Div>
                                <Div className="scl-b-row">
                                    <Grid
                                        size={{ xs: 12, md: 4 }}
                                    >
                                        <FormField
                                            label="Address line 1"
                                            type={FieldTypes.Text}
                                            value={props.general.policyHolder.addressLine1}
                                            asSummary
                                        />
                                    </Grid>
                                    <Grid
                                        size={{ xs: 12, md: 4 }}
                                    >
                                        <FormField
                                            label="Address line 2"
                                            type={FieldTypes.Text}
                                            value={props.general.policyHolder.addressLine2}
                                            asSummary
                                        />
                                    </Grid>
                                    <Grid
                                        size={{ xs: 12, md: 4 }}
                                    >
                                        <FormField
                                            label="Zip code"
                                            type={FieldTypes.Text}
                                            value={props.general.policyHolder.zipCode}
                                            asSummary
                                        />
                                    </Grid>
                                </Div>
                                <Div className="scl-b-row">
                                    <Grid
                                        size={{ xs: 12, md: 4 }}
                                    >
                                        <FormField
                                            label="House number"
                                            type={FieldTypes.Text}
                                            value={props.general.policyHolder.houseNumber}
                                            asSummary
                                        />
                                    </Grid>
                                    <Grid
                                        size={{ xs: 12, md: 4 }}
                                    >
                                        <FormField
                                            label="House number addition"
                                            type={FieldTypes.Text}
                                            value={props.general.policyHolder.houseNumberAddition}
                                            asSummary
                                        />
                                    </Grid>
                                    <Grid
                                        size={{ xs: 12, md: 4 }}
                                    >
                                        <FormField
                                            label="Residence"
                                            type={FieldTypes.Text}
                                            value={props.general.policyHolder.residence}
                                            asSummary
                                        />
                                    </Grid>
                                </Div>
                            </FieldSet>
                    }
                    <FieldSet title="Reporting">
                        <Div className="scl-b-row">
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <FormField
                                    type={FieldTypes.Text}
                                    label="Soa name"
                                    value={props.general.soaName}
                                    asSummary
                                />
                            </Grid>
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <FormField
                                    type={FieldTypes.Text}
                                    label="Product code VWFS"
                                    value={props.general.productCodeVWFS}
                                    asSummary
                                />
                            </Grid>
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <FormField
                                    type={FieldTypes.Text}
                                    label="Coverage code VWFS"
                                    value={CoverageLevelDisplay[props.general.coverageCodeVWFS] as string}
                                    asSummary
                                />
                            </Grid>
                        </Div>
                    </FieldSet>
                    <FieldSet title="Terms and conditions">
                        <FormTextArea
                            label=""
                            value={props.general.termsAndConditions}
                            asSummary
                        />
                    </FieldSet>
                </Form>
            </Container>
        </Div>
    </React.Fragment>
);
